import { S, SA, DC, RCL, ACL, RCLA, TEXT } from '../../Utilities';
import './style.sss';

export default class Sliders {
    
    constructor(slider, label = 'Bekijk schermvullend') {
        this.elSlider = S(slider);
        this.timer = null;
        this.interval = 6;
        this.currentSlider = 0;
        this.showReal = '';

        if (this.elSlider) {
            this.elSlides = SA('ul li', this.elSlider);
            this.total = this.elSlides.length;
            this.label = label;
            this.showRealItems = [];

            DC('div', 'sliders_full_screan');
            this.start();
            
        }
    }

    async start() {
        await this.render();
        this.switch();
        this.slider();
        this.controllers();
    }

    render() {
        return new Promise((resolve, reject) => {
            this.btn = DC('div', 'sliders_full_screen');
            const btn = DC('div', 'sliders_full_screen_btn');
            const label = DC('div', 'sliders_full_screen_label');
            const txt = TEXT(this.label);
            label.appendChild(txt);
            this.btn.appendChild(btn);
            this.btn.appendChild(label);
            this.elSlider.appendChild(this.btn);
            this.btnWrapper = DC('div', 'sliders_full_screen_btn_wrapper');
            this.btnLeft = DC('span', 'sliders_full_screen_btn_left');
            this.btnRight = DC('span', 'sliders_full_screen_btn_right');
            this.legend = DC('span', 'sliders_full_screen_legend');
            

            //create showReal
            this.showReal = DC('div', 'sliders_show_real');
            const list = DC('ul', 'sliders_show_real_list');
            
            [...this.elSlides].forEach(item => {
                const li = DC('li', 'sliders_show_real_list_item');
                li.style.backgroundImage = item.style.backgroundImage;
                this.showRealItems.push(li);
                list.appendChild(li);
            });
            this.showReal.appendChild(list);
            if (this.elSlides.length > 1) {
                this.btnWrapper.appendChild(this.btnLeft);
                this.btnWrapper.appendChild(this.btnRight);
            }

            this.close = DC('span', 'sliders_full_screen_close close_btn');
            const closeSpan_1 = DC('span', 'close_cross_1');
            const closeSpan_2 = DC('span', 'close_cross_2');
            this.close.appendChild(closeSpan_1);
            this.close.appendChild(closeSpan_2);
            
            this.showReal.appendChild(this.btnWrapper);
            this.showReal.appendChild(this.close);
            this.showReal.appendChild(this.legend);


            
            

            const body = S('body');
            body.appendChild(this.showReal);
            resolve(this);
        });
        
    }

    switch() {
        RCLA(this.elSlides, 'show');
        ACL(this.elSlides[this.currentSlider], 'show');
        RCLA(this.showRealItems, 'show');
        ACL(this.showRealItems[this.currentSlider], 'show');
        this.legend.innerHTML = `${this.currentSlider + 1} / ${this.total}`;
        this.btnRight.style.backgroundImage = this.showRealItems[(this.currentSlider + 1) > this.total - 1 ? 0 : this.currentSlider + 1].style.backgroundImage;

    }


    controllers() {
        this.btn.addEventListener('click', () => this.openShowReal() );
        this.close.addEventListener('click', () => this.closeShowReal());
        if (this.elSlides.length > 1) {
            this.btnRight.addEventListener('click', () => {
                this.currentSlider = this.currentSlider >= this.total - 1 ? 0 : this.currentSlider + 1;
                this.switch();
            });
            this.btnLeft.addEventListener('click', () => {
                this.currentSlider = this.currentSlider <= 0 ? this.total - 1 : this.currentSlider - 1;
                this.switch();
            });
        }
        
    }


    slider() {
        this.timer = setInterval(() => {
            this.currentSlider = this.currentSlider >= this.total - 1 ? 0 : this.currentSlider + 1;            
            this.switch();
        }, this.interval * 1000)
    }

    closeShowReal() {
        RCL(this.showReal, 'show');
    }

    openShowReal() {
        clearInterval(this.timer);
        
        ACL(this.showReal, 'show');
    }
    
}